<section *ngIf="blogList" class="mini-blog-section mt-20">

  <h4 class="blog-section-heading  d-none d-lg-block">Related Blogs</h4>
  <div class="d-flex d-lg-none justify-content-between align-items-center mb-26">
    <h2 class="section-heading">Related Blogs</h2>
    <div class="ml-auto d-flex align-items-center">
      <a href="{{baseUrl + '/blogs'}}" target="_blank" title="blog view all" class="view-all-outline-btn border-0 ms-3">
        View All </a>
    </div>
  </div>
  <div class="blog-card-list">
    <ng-container *ngFor="let item of blogList">
      <div class="card card-13  box-shadow-unset h-100 cursor " routerLink="/blogs/{{item?.slug}}">
        <div class="card-header">
          <img *ngIf="item?.imageLink" [src]="item?.imageLink" [alt]="item?.title + ' - TenderShark'" class="main-img">
          <!-- <img *ngIf="item?.imageLink" loading="eager" [src]="item.imageLink" width="295px" height="135px"
        alt={{item.title}} class="main-img" loading="lazy"> -->
        </div>
        <div class="card-body text-start">
          <span class="date">{{item?.date | date:"MMM dd, YYYY"}}</span>
          <a href="{{baseUrl + '/blogs/'+ item?.slug}}" class="blog-card-title" style="color: black;">{{item?.title}}
          </a>
          <span class="read-more-cta ng-tns-c19-1" tabindex="0">Read More<i
              class="sprite-img blue-arrow-right ng-tns-c19-1"></i></span>
        </div>
      </div>

    </ng-container>
  </div>
  <a href="{{baseUrl + '/blogs'}}" target="_blank" class="btn btn-outline-warning d-none d-lg-flex">View All
    <i class="arrow-right-red sprite-img"></i>
  </a>
  <!-- <div class="blog-list-slider w-100"
    [ngClass]="{'with-scroll-container': isScroll, 'without-scroll-container': !isScroll}">
    <div [id]="containerId" id="{{containerId}}" class="inner-container" (scroll)="onSliderScroll($event)">
      <div *ngFor="let item of blogList">
    
      </div>
      <span class="left-arrow arrow" *ngIf="isLeftVisible && blogList.length >1" (click)=" scrollSliderDiv(false)"
        [class.hide-arrow-div]="hideContainer">
        <i class="sprite-img icon-back "></i>
      </span>
      <span class="right-arrow arrow" *ngIf="isRightVisible && blogList.length >1" (click)="scrollSliderDiv(true)"
        [class.hide-arrow-div]="hideContainer">
        <i class="sprite-img icon-next cursor "></i>
      </span>
    </div>
  </div> -->

</section>